export default __webpack_public_path__ + "static/media/RobotoSlab-Regular.db79495b.woff";